import { render } from "./LifetimeAwardPage.vue?vue&type=template&id=eae30538&ts=true"
import script from "./LifetimeAwardPage.vue?vue&type=script&lang=ts"
export * from "./LifetimeAwardPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__